import * as Yup from "yup";

export const removeSupplyValidationSchema = Yup.object().shape({
  requestingCompany: Yup.mixed().when("$noCompany", {
    is: (noCompany: boolean) => !noCompany,
    then: (schema) => schema.required("Please select"),
    otherwise: (schema) => schema.nullable(),
  }),
  nmi: Yup.string().when("energyType", {
    is: "electricity",
    then: (schema) =>
      schema
        .required("Oops, you must enter a NMI.")
        .matches(
          /^(?:\d{10}|[A-Za-z\d]{10})$/,
          "Oops, NMI must be 10 characters"
        ),
    otherwise: (schema) => schema.nullable(),
  }),
  mirn: Yup.string().when("energyType", {
    is: "naturalGas",
    then: (schema) =>
      schema
        .required("Oops, you must enter a MIRN.")
        .matches(/^\d{10}$/, "Oops, MIRN must be 10 characters"),
    otherwise: (schema) => schema.nullable(),
  }),
});

export const removeSupplyElectricityValidationSchema = Yup.object().shape({
  abolishmentDate: Yup.mixed()
    .nullable()
    .required("Date format should be DD/MM/YYYY")
    .test("is-valid-date", "Date format should be DD/MM/YYYY", (value) => {
      if (value === null) return false; // Fail if null (required)
      return value instanceof Date && !isNaN(value.getTime());
    }),
  abolishmentForm: Yup.array().when(["$state", "$energyType"], {
    is: (state: string, energyType: string) =>
      state === "VIC" && energyType === "electricity",
    then: (schema) =>
      schema
        .min(1, "Please upload a document")
        .required("Please upload a document"),
    otherwise: (schema) => schema.nullable(),
  }),
});
